// extracted by extract-css-chunks-webpack-plugin
module.exports = {"layout":"app-components-sidebar-layout--layout"};